import React, { useEffect, useState } from "react";
import { ref, onValue, get } from "firebase/database";
import { db } from "../../firebase";
import { useParams, useNavigate } from "react-router-dom";
import "./EfcVideos.css";

const EfcVideos = () => {

  const { subject } = useParams();
  const navigate = useNavigate();

  const [videos, setVideos] = useState([]);
  const [premium, setPremium] = useState(false);
  const [showPremium, setShowPremium] = useState(false);

  // ================= CHECK PREMIUM =================

  useEffect(() => {

    const uid = localStorage.getItem("uid");

    if (!uid) {
      setPremium(false);
      return;
    }

    get(ref(db, "users/" + uid)).then((snap) => {
      if (snap.exists()) {
        setPremium(snap.val().is_premium === true);
      }
    });

  }, []);

  // ================= THUMBNAIL FIX =================

  const getThumbnail = (videoUrl, thumbUrl) => {

    // Google Drive CDN
    if (thumbUrl && thumbUrl.includes("drive.google.com")) {

      let fileId = "";

      const match1 = thumbUrl.match(/\/d\/([a-zA-Z0-9_-]+)/);
      const match2 = thumbUrl.match(/[?&]id=([a-zA-Z0-9_-]+)/);

      const match = match1 || match2;

      if (match) fileId = match[1];

      if (fileId) {
        if (fileId) {
  if (fileId) {
  return `https://drive.google.com/thumbnail?id=${fileId}&sz=w1000`;
}

}

      }
    }

    // Normal Image
    if (thumbUrl) return thumbUrl;

    // YouTube Auto Thumb
    if (videoUrl && videoUrl.includes("youtube")) {

      const id = videoUrl.split("v=")[1]?.split("&")[0];

      if (id) {
        return `https://img.youtube.com/vi/${id}/hqdefault.jpg`;
      }
    }

    return "";
  };

  // ================= FETCH VIDEOS =================

  useEffect(() => {

    const efcRef = ref(db, "videos/efc");

    onValue(efcRef, (snap) => {

      const data = snap.val();

      if (!data || !data[subject]) {
        setVideos([]);
        return;
      }

      const subjectData = data[subject];

      const list = Object.keys(subjectData).map(id => {

        const v = subjectData[id];

        return {
          id,
          title: v.title || "No Title",
          videoUrl: v.videoUrl || v.vimeoUrl,
          thumbnailUrl: getThumbnail(
            v.videoUrl || v.vimeoUrl,
            v.thumbnailUrl
          )
        };

      });

      setVideos(list);

    });

  }, [subject]);

  // ================= OPEN VIDEO =================

  const openVideo = (url) => {

    if (!url) return;

    // 🔒 BLOCK FREE USERS
    if (!premium) {
      setShowPremium(true);
      return;
    }

    // YouTube external
    if (url.includes("youtube") || url.includes("youtu.be")) {
      window.open(url, "_blank");
      return;
    }

    // Internal player
    navigate("/player", {
      state: { url }
    });
  };

  // ================= BUY PREMIUM =================

  const handleBuyPremium = () => {
    setShowPremium(false);
    navigate("/counselling-program");
  };

  return (

    <div className="efc-page">

      <h2>{subject}</h2>

      {/* GRID */}

      <div className="efc-grid">

        {videos.map(video => (

          <div
            key={video.id}
            className="efc-card"
            onClick={() => openVideo(video.videoUrl)}
          >

            <img
              src={video.thumbnailUrl}
              alt=""
              className="efc-thumb"
             onError={(e) => {
  e.target.onerror = null;
  e.target.src = "/fallback.jpg";
}}

            />

            <div className="efc-title">
              {video.title}
            </div>

          </div>

        ))}

      </div>

      {/* ================= PREMIUM MODAL ================= */}

      {showPremium && (
        <div className="modal-backdrop">

          <div className="modal">

            <h3>Premium Access Required</h3>

            <p>
              Enroll for Counselling Program to access this content.
            </p>

            <div className="modal-actions">

              <button onClick={() => setShowPremium(false)}>
                CANCEL
              </button>

              <button onClick={handleBuyPremium}>
                ENROLL NOW
              </button>

            </div>

          </div>

        </div>
      )}

    </div>
  );
};

export default EfcVideos;
